module.exports = __webpack_public_path__ + "img/stackslash-process-2.24031a04.jpg";